module.exports = __webpack_public_path__ + "static/media/teresa-viera.bfcbf27a.jpg";